'use client'

import type {CustomerHostAuth} from '@fitro/customer-features/host-contract'
import {useAuth, useClerk, useUser} from '@/lib/clerk-nextjs'

export {useAuth, useClerk, useUser}

;({useAuth, useUser, useClerk}) satisfies CustomerHostAuth
